#import "../fragments/ai-search-result-fragment.graphql"

query GetAiSearchResults($query: String!) {
    aiSearch(query: $query) {
        ...AiSearchResultFragment
    }
}
